import { format } from 'date-fns';

const DATE_PATTERN = 'yyyy-MM-dd';

export const formatDate = date => format(date, DATE_PATTERN);
